{
  document.addEventListener('DOMContentLoaded', () => {
    // Select all buttons with the class 'svt-btn-form'
    const newsButtons = document.querySelectorAll('.svt-btn-form');

    // Iterate over each button
    newsButtons.forEach(button => {
      // Check if the button doesn't have the class 'side-line-not'
      if (!button.classList.contains('side-line-not')) {
        // Create the left side div
        const leftDiv = document.createElement('div');
        leftDiv.className = 'svt-btn__side-line svt-btn__side-line--left';

        // Create the right side div
        const rightDiv = document.createElement('div');
        rightDiv.className = 'svt-btn__side-line svt-btn__side-line--right';

        // Add the side divs to the button
        button.prepend(leftDiv);
        button.appendChild(rightDiv);
      }
    });

    // Select all buttons with the classes 'wp-block-button__link' and 'wp-element-button'
    const wpButtons = document.querySelectorAll('a.wp-block-button__link.wp-element-button');

    // Iterate over each button
    wpButtons.forEach(button => {
      // Check if the button doesn't have the class 'side-line-not'
      if (!button.classList.contains('side-line-not')) {
        // Create the left side div
        const leftDiv = document.createElement('div');
        leftDiv.className = 'wp-element-button__side-line wp-element-button__side-line--left';

        // Create the right side div
        const rightDiv = document.createElement('div');
        rightDiv.className = 'wp-element-button__side-line wp-element-button__side-line--right';

        // Add the side divs to the button
        button.prepend(leftDiv);
        button.appendChild(rightDiv);
      }
    });

    // Add caret icons to select containers
    const selectContainers = document.querySelectorAll('.svt-el-input--content');
    selectContainers.forEach(container => {
      const iconDiv = document.createElement('div');
      iconDiv.className = 'svt-icon-caret';
      container.appendChild(iconDiv);
    });

    // Modify the aria-label of the label element inside the signup container
    const signupContainer = document.querySelector('.svt-ct-signup-news');
    if (signupContainer) {
      const label = signupContainer.querySelector('label[aria-label="terms & conditions"]');
      if (label) {
        label.setAttribute('aria-label', 'Sign Up for Our Newsletter');
      }
    }

    // Select all buttons with the specified classes
    const buttons = document.querySelectorAll('.svt-btn-form.svt-link-icon');

    // The SVG element to be added
    const svgElement = `<svg aria-hidden="true" focusable="false">
                                      <use href="/wp-content/uploads/2024/07/svt-icons.svg#icon-Icon-Retro-Arrow-1"></use>
                                  </svg>`;

    // Iterate over each button and add the SVG
    buttons.forEach(button => {
      button.insertAdjacentHTML('beforeend', svgElement);
    });
  });
}
